var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewTab = function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.687a1.167 1.167 0 001.167-1.166v-5a.5.5 0 111 0v5A2.167 2.167 0 0115 17.687H5a2.167 2.167 0 01-2.167-2.166v-10A2.167 2.167 0 015 3.354h5a.5.5 0 010 1H5A1.167 1.167 0 003.833 5.52v10A1.166 1.166 0 005 16.687h10z",
    fill: "#089BEE;",
    stroke: "#089BEE;",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.354 7.167a.5.5 0 010 .707l-5 5a.5.5 0 01-.708-.707l5-5a.5.5 0 01.708 0z",
    fill: "#089BEE;",
    stroke: "#089BEE;",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 7.52a.5.5 0 01.5-.5H13a.5.5 0 01.5.5v4.167a.5.5 0 11-1 0V8.021H8.833a.5.5 0 01-.5-.5z",
    fill: "#089BEE;",
    stroke: "#089BEE;",
    strokeWidth: 0.5
  })));
};
export default SvgNewTab;